import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

export default function initGSAP() {
  const mm = gsap.matchMedia();
  const header = document.querySelector('.header');
  const headerText = header?.querySelector('.logo__text');
  const imgHolder = document.querySelector('[data-show-img]');
  const viewPortEls = document.querySelectorAll('[data-viewport]');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  const caseDivs = document.querySelectorAll('[data-set-header-mobile]');
  const animateTextEls = document.querySelectorAll('[data-animate-holder]');
  const sections = document.querySelectorAll('section, .about-slider__wrapper, [data-set-header-bg], [data-set-logo]');

  function changeLogoColor() {
    const hasCaseStudiesOverview = document.querySelector('.case-studies-overview');
    const isCaseStudyDetailPage = document.querySelector('.caseStudyDetail');

    if (!sections.length || !header) return;

    if (isMobile) {
      if (!caseDivs.length) return;

      caseDivs.forEach(element => {
        const initialHeader = header.dataset.logo;

        ScrollTrigger.create({
          trigger: element,
          start: `top top+=33px`,
          end: `bottom top+=33px`,
          onEnter: () => {
            header.style.setProperty(
              'background-color',
              element.dataset.setHeaderMobile,
              'important'
            );
            header.dataset.logo = element.dataset.setLogo;
          },
          onEnterBack: () => {
            header.style.setProperty(
              'background-color',
              element.dataset.setHeaderMobile,
              'important'
            );
            header.dataset.logo = element.dataset.setLogo;
          },
          onLeave: () => {
            header.style.setProperty(
              'background-color',
              '#fffefd',
              'important'
            );
            header.dataset.logo = initialHeader;
          },
          onLeaveBack: () => {
            header.style.setProperty(
              'background-color',
              '#fffefd',
              'important'
            );
            header.dataset.logo = initialHeader;
          }
        })
      });
      return;
    }

    if (hasCaseStudiesOverview) {
      return;
    }

    sections.forEach(section => {
      let sectionBg = window.getComputedStyle(section).backgroundColor || null;
      const offset = section.dataset.offset;

      if (isCaseStudyDetailPage) {
        sectionBg = `#fff`;
      }

      ScrollTrigger.create({
        trigger: section,
        start: `top top+=${offset ? offset : `33px`}`,
        end: `bottom top+=${offset ? offset : `33px`}`,
        onEnter: () => {
          header.style.backgroundColor = sectionBg;
          header.dataset.logo = section?.dataset.setLogo || '';

          if (section.classList.contains('about-slider__wrapper')) {
            header.style.backgroundColor = 'var(--header-bg)';
            header.dataset.sliderHeader = '';
            header.dataset.logo = section.querySelector('.swiper-slide-active')?.dataset.setLogo || '';
          }
        },
        onEnterBack: () => {
          header.style.backgroundColor = sectionBg;
          header.dataset.logo = section?.dataset.setLogo || '';

          if (section.classList.contains('about-slider__wrapper')) {
            header.style.backgroundColor = 'var(--header-bg)';
            header.dataset.sliderHeader = '';
            header.dataset.logo = section.querySelector('.swiper-slide-active')?.dataset.setLogo || '';
          }
        },
        onLeave: () => {
          if (section.classList.contains('topics')) {
            return;
          }

          if (section.classList.contains('about-slider__wrapper')) {
            header.removeAttribute('data-slider-header');
          }
        }
      });
    });
  }

  function stickyHeader() {
    if (!header) return;
    const hasHero = document.querySelector('.hero');
    const hasCaseStudy = document.querySelector('.case-study');
    const hasCampaignDetail = document.querySelector('.campaign-detail');
    const hasCaseStudiesOverview = document.querySelector('.case-studies-overview');
    const hasCampaignOverview = document.querySelector('.campaign-overview');

    if (hasCaseStudiesOverview) {
      header.dataset.logo = "dark-white";
      header.classList.add('has-red-background-color');
    }

    if (hasCampaignOverview) {
      header.dataset.logo = "dark-red";
      header.classList.add('has-paper-background-color');
    }

    if (isMobile) {
      if (!hasHero && !hasCaseStudy && !hasCampaignDetail) {
        header.dataset.logo = "dark";
        header.classList.add('has-red-background-color');
      } else if (hasCaseStudy) {
        header.dataset.logo = "dark-red";
        header.classList.add('has-paper-background-color');
      }
    }

    ScrollTrigger.create({
      start: () => header.offsetHeight,
      onEnter: () => {
        if (headerText) {
          headerText.setAttribute('hidden', '');
        }

        if (!isMobile || hasCaseStudy) return;

        if (hasCampaignDetail) {
          header.classList.add('has-dark-background-color');
          header.dataset.logo = "light-red";
        } else {
          header.classList.add('has-red-background-color');
          header.dataset.logo = "dark";
        }
      },
      onLeaveBack: () => {
        if (headerText) {
          headerText.removeAttribute('hidden');
        }

        if (!isMobile || !hasHero) return;

        header.classList.remove('has-red-background-color');
        header.dataset.logo = "";
      }
    });
  }

  function animateText() {
    if (!animateTextEls.length) return;

    animateTextEls.forEach((holder) => {
      const texts = holder.querySelectorAll('[data-animate-text]');
      if (!texts.length) return;

      ScrollTrigger.create({
        trigger: holder,
        start: 'top bottom', // Initialize when enters viewport
        once: true,
        onEnter: () => {
          // Double innerHTML for each text element safely
          texts.forEach((text) => {
            if (text) text.innerHTML += text.innerHTML;
          });

          // Set staggered initial positions
          texts.forEach((text, index) => {
            const isOffset = index % 2 !== 0;
            gsap.set(text, { xPercent: isOffset ? -100 : 0 });

            // Create the scrubbed animation
            gsap.to(text, {
              xPercent: isOffset ? 0 : -100,
              ease: 'none',
              scrollTrigger: {
                trigger: holder,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
              },
            });
          });
        },
      });
    });
  }

  function showImage() {
    if (!imgHolder || isDesktop) return;

    imgHolder.querySelectorAll("a").forEach(item => {
      ScrollTrigger.create({
        trigger: item,
        start: `top center+=${item.offsetHeight}`,
        end: `bottom center+=${item.offsetHeight + 1}`,
        onEnter: () => {
          item.classList.add('active');
        },
        onEnterBack: () => {
          item.classList.add('active');
        },
        onLeave: () => {
          item.classList.remove('active');
        },
        onLeaveBack: () => {
          item.classList.remove('active');
        }
      })
    });
  }

  function inViewPort() {
    if (!viewPortEls.length) return;

    viewPortEls.forEach(element => {
      ScrollTrigger.create({
        trigger: element,
        end: "bottom+=10% top",
        onEnter: () => element.classList.add('in-viewport'),
      });
    });
  }

  function stickyImg() {
    const stickySections = document.querySelectorAll('.sticky__holder');
    if (!stickySections.length || !header || isMobile) return;

    stickySections.forEach(section => {
      const banner = section?.querySelector('.sticky__img');
      if (!banner) return;

      mm.add("(min-width: 1024px)", () => {
        gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: `top ${header.offsetHeight}`,
            end: `bottom top`,
            pin: true,
            scrub: true,
          }
        })
          .fromTo(
            banner,
            { y: 0 },
            {
              y: () => section.offsetHeight - (banner.offsetHeight)
            },
          );
      });
    });
  }

  stickyImg();
  showImage();
  inViewPort();
  animateText();
  stickyHeader();
  changeLogoColor();

  window.addEventListener('resize', () => {
    ScrollTrigger.refresh(true);
  });
}
